<template>
    <div class="filter-item filter-item--dropdown">
        <h2 class="filter-item__heading" v-text="title"></h2>
        <search-selector :search="search" v-model="value" :options="options" :icon-type="filterName"></search-selector>
    </div>
</template>

<script>
import OptionSelector from '../selector.vue'
import SearchSelector from './../search-selector.vue';
import { trackEvent } from '../../tracker';
export default {
    props: {
        title: {type: String, default: ''},
        options: {type: [Array, Object], default() {return [ ]}},
        filterName: {type: String, default: null},
        icon: {type: String, default: ''},
        filterValue: {type: String, default: ''},
        search: {type: Boolean, default: false}
    },
    data() {
        return {
            value: 'all'
        }
    },
    mounted() {
        this.value = this.$route.query[this.filterValue] || 'all';
        this.readArrayValue();
    },
    methods: {
        readArrayValue() {
            if(this.value && Array.isArray(this.value) && this.value[0]) {
                this.value = this.value[0];
            }
        }
    },
    watch: {
        value(newVal, oldVal) {
            if(newVal === 'all') {
                newVal = null;
            }
            
            let query = Object.assign({}, this.$route.query);
            query[this.filterValue] = newVal;
            this.$router.replace({query}, (to, from, next) => {
                let value = this.options.filter((option) => (option == newVal || option.value == newVal));

                trackEvent({
                    event: 'Filter - ' + this.title,
                    target: to.fullPath,
                    value: (value.length) ? value[0] : newVal,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        },
        '$route.query'() {
            if(typeof this.$route.query[this.filterValue] != 'undefined') {
                this.value = this.$route.query[this.filterValue];
                this.readArrayValue();
            } else {
                this.value = 'all';
            }
        }
    },
    components: {
        OptionSelector,
        SearchSelector
    }
}
</script>

